<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Retraite Complémentaire Salarié</h2>
  </div>

  <!-- Main Content -->
  <div class="content-section main-content">
    <p>
      Si vous êtes à la recherche de ce type d'assurance <strong class="text-purple">Retraite Complémentaire Salarié</strong>, merci de prendre contact avec nous car il existe beaucoup trop de déclinaisons selon votre situation personnelle.
    </p>
    
    <p>
      Le <strong class="text-purple">courtier en Assurance BROKINS</strong> est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, SWISSLIFE, ALPTIS, MALAKOFF HUMANIS...</strong>
    </p>
    
    <!-- Devis Button -->
    <div class="devis-button-wrapper">
      <button class="btn-devis" (click)="navigateToComparison()">
        Devis en ligne
      </button>
    </div>
  </div>

  <!-- Additional Information -->
  <div class="content-section additional-info">
    <p>
      Il faudra bien vérifier si l'entreprise dans laquelle vous travaillez n'a pas déjà souscrit une <a href="/assurance-retraite-complementaire-entreprise" class="link-purple">Assurance Retraite Complémentaire Entreprise</a>, dont vous trouverez plus de détails ici.
    </p>
  </div>


</app-page-layout>

